$(window).on('scroll', function (){

  var elem = $('.elem');
  var appear = 'appear';

  elem.each(function () {

    var elemOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();

    if(scrollPos > elemOffset - wh + (wh / 5) ){
      $(this).removeClass(appear);
    }
  });
});

$(function(){
  $('.closeSerchModal').on('click',function(){
    $('.serchBox').fadeOut(500);
  });
  $('.titleSearch').on('click',function(){
    $('.serchBox').fadeIn(500);
  });
});
